import { createi18nInstance } from '@pletly/common';
import { resources } from './locales/index';

const defaultNS = 'feature-organisation';

const i18n = createi18nInstance({
	resources,
	defaultNS: defaultNS,
});

export default i18n;
